import { Navigate, Route, Routes } from "react-router-dom";
import DecreesBox from "./DecreesBox";

/**
 * Trasy skrzynki dekretów: „Do wykonania" (dekrety wydane do mnie) i „Wydane"
 * (dekrety, które ja wydałem). Wiersz prowadzi do przesyłki w Przychodzących.
 */
const DecreesRoute = () => {
  return (
    <Routes>
      <Route path="/received" element={<DecreesBox box="received" />} />
      <Route path="/issued" element={<DecreesBox box="issued" />} />
      <Route path="/*" element={<Navigate to="received" replace />} />
    </Routes>
  );
};

export default DecreesRoute;
